import React, { Fragment } from 'react'
import HomeInvestorLoan from "website/home/home-investor-loan.svg"
import ConstructionLoan from "website/home/construction-loan.svg"
import BridgingLoan from "website/home/bridging-loan.svg"
import SmsfLoan from "website/home/smsf-loan.svg"
import OurLoansImage from "website/home/our-loans-image.svg"
import CommercialPropertyLoan from "website/home/commersial-property-loan.svg"

const OurLoansForYou = () => (
  <div className="our-loans-for-you-container">
    <div className='our-loans-image-container-mobile'>
      <OurLoansImage />
    </div>
    <h3 className="text-center mb-5">Our loans for you</h3>
    <div className="our-loans-body-container">
      <div>
        <a href='/loans'>
          <div className="our-loans-contents-container">
              <HomeInvestorLoan />
              <div className="texts-container">
                <h4><b>Home / Investor Loan</b></h4>
                <p>Purchase or refinance a property for your own home or an investment</p>
              </div>
          </div>
        </a>

        <a href='/loans/construction-loan'>
          <div className="our-loans-contents-container">
              <ConstructionLoan />
              <div className="texts-container">
                <h4><b>Construction Loan</b></h4>
                <p>Short-term loan that provides the funds to build a residential property</p>
              </div>
          </div>
        </a>

        <a href='/loans/bridging-loan'>
          <div className="our-loans-contents-container">
              <BridgingLoan />
              <div className="texts-container">
                <h4><b>Bridging Loan</b></h4>
                <p>Consider Yard's bridging loan if you need to buy before going through the process of selling an existing property</p>
              </div>
          </div>
        </a>

        <a className='link' href='/loans/smsf-loan'>
          <div className="our-loans-contents-container">
              <SmsfLoan />
              <div className="texts-container">
                <h4><b>SMSF Loan</b></h4>
                <p>Purchase or refinance a residential and commercial property through your Self-Managed Super Fund (SMSF)</p>
              </div>
          </div>
        </a>

        <a className='link' href='/loans/commercial-property-loan'>
          <div className="our-loans-contents-container">
              <CommercialPropertyLoan />
              <div className="texts-container">
                <h4><b>Commercial Property Loan</b></h4>
                <p>Purchase or refinance a commercial property with our flexible commercial loan options</p>
              </div>
          </div>
        </a>
      </div>
      <div className='our-loans-image-container'>
        <OurLoansImage />
      </div>
    </div>
  </div>
);

export default OurLoansForYou
